import React, { useEffect, useState } from "react";
import "./mytests.scss";
import { Table, Modal, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import SelectQuestions from "./selectQuestions";
import { Alert, Snackbar, Dialog } from "@mui/material";
import Select, { components } from "react-select";
import {
  resetQuestions,
  getv2AdditionalQuestion,
  getNextv2AdditionalQuestion,
  getQuestionLevels,
  selectOneQuestion,
  removeQuestion,
  saveSelectQuestion,
  checkValidTest,
  getTestById,
  getCodingQuestionLanguages,
  getCodingAdditionalQuestion,
  resetLanguages,
  resetLoadingQuestions,
} from "../../Redux/ActionCreators/testLibraryAction";
import {
  resetMYTest,
  getMyTests,
  getNextMyTests,
  getQuestionSource,
  getSkills,
  getSkillTopics,
  getQuestionCount,
  savedTest,
  updateTest,
  emptyTopics,
  getCodingQuestionCount,
  resetSkills,
  resetTopics,
} from "../../Redux/ActionCreators/myTestsAction";
import { getTotal } from "../../utils/miscelleneous";
import { useNavigate } from "react-router-dom";
import EditTestModal from "./editTestModal";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img src="/images/mdi_menu-down.svg" alt="" />
    </components.DropdownIndicator>
  );
};

function MyTests() {
  const [isLoading, setIsLoading] = useState(false);
  const [isNewTestPage, setIsNewTestPage] = useState(false);
  const [selectQuestionsMode, setSelectQuestionsMode] = useState(null);
  const [successMessageText, setsuccessMessageText] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const [testName, setTestName] = useState("");
  const [testNameErr, setTestNameErr] = useState("");
  const [shouldValidate, setShouldValidate] = useState(false);
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [testType, setTestType] = useState(-1);
  const [qSource, setQSource] = useState("");
  const [skill, setSkill] = useState("");
  const [topic, setTopic] = useState("");
  const [level, setLevel] = useState("");
  const [qCount, setQCount] = useState("");
  const [countOption, setCountOption] = useState([]);
  const [automaticQues, setAutomaticQues] = useState([]);
  const [searchQues, setSearchQues] = useState("");
  const [quesPage, setQuesPage] = useState(1);
  const [isEdit, setIsEdit] = useState(false);
  const [duration, setDuration] = useState(0);
  const [editDetails, setEditDetails] = useState("");
  const [isEditTopic, setIsEditTopic] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [assessmentType, setAssessmentType] = useState("general");
  const [codingLanguages, setCodingLanguages] = useState([]);
  const [selectedCodingLanguage, setSelectedCodingLanguage] = useState(null);
  const [categoryId, setCategoryId] = useState(1);

  const [editTopicDetail, setEditTopicDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isQuestionLoadingCustom, setIsQuestionLoadingCustom] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    myTests,
    total,
    questionSource,
    skills,
    topics,
    count,
    isTestLoading,
    testTypes,
  } = useSelector((state) => state.myTests);
  const {
    questionLevel,
    isQuestionLoading,
    additionalQuestions,
    totalQues,
    selectedQuestion,
    codingQuestionLanguagesOptions,
  } = useSelector((state) => state.testLibrary);

  const testsPerPage = 10;

  useEffect(() => {
    const init = async () => {
      await dispatch(resetMYTest());
      await dispatch(getMyTests(testType, query, page, testsPerPage));
      await dispatch(getQuestionSource());
    };
    init();
  }, []);

  const fetchData = () => {
    setPage(page + 1);
    dispatch(getNextMyTests(testType, query, page + 1, testsPerPage));
  };

  const timerRef1 = React.useRef(null);

  const searchTest = (val) => {
    clearTimeout(timerRef1.current);
    setQuery(val);
    setPage(1);
    timerRef1.current = setTimeout(() => delaySearch(val), 800);
  };

  const delaySearch = async (val) => {
    await dispatch(resetMYTest());
    await dispatch(getMyTests(testType, val, page, testsPerPage));
  };

  const selectTestType = async (val) => {
    setTestType(val);
    setPage(1);
    await dispatch(resetMYTest());
    await dispatch(getMyTests(val, query, 1, testsPerPage));
  };

  const getQuestionTypeIds = (assessmentType, testType, categoryId) => {
    if (assessmentType === "technical" && testType === 7) {
      switch (categoryId) {
        case 1:
          return [7];
        case 2:
          return [12];
        case 3:
          return [13];
        default:
          return [];
      }
    }
    return [];
  };

  const createTest = async () => {
    if (window.innerWidth > 767) {
      await dispatch(resetQuestions());
      setIsNewTestPage(true);
      setSelectQuestionsMode(null);
      setTestName("");
      setTestNameErr("");
      setShouldValidate(false);
      setEditDetails(null);
      setAutomaticQues([]);
      setEditTopicDetail(null);
      setSelectedCodingLanguage(null);
    } else {
      setSuccessMessage(true);
      setsuccessMessageText(
        "You can create test from Desktop.Mobile view coming soon"
      );
    }
  };

  useEffect(() => {
    if (!shouldValidate) return;
    const delay = setTimeout(() => {
      validateNameViaApi(testName);
    }, 200);

    return () => clearTimeout(delay);
  }, [testName, shouldValidate]);

  const validateNameViaApi = async (input) => {
    const res = input !== "" && (await dispatch(checkValidTest(input)));
    if (res?.payload?.isValid) {
      setTestNameErr("");
    } else {
      setTestNameErr("Test Name already exist");
    }
  };

  const goBack = () => {
    setIsNewTestPage(false);
  };

  const goBackNewTest = () => {
    clearResponse();
    setIsNewTestPage(editDetails ? false : true);
    setSelectQuestionsMode(null);
    setTestType(-1);
  };

  const handleTestName = (val) => {
    setTestName(val);
    setTestNameErr("");
    setShouldValidate(true);
  };

  const setMode = async (mode) => {
    if (!testName) {
      setSuccessMessage(true);
      setsuccessMessageText("Please enter Test Name");
    } else if (!assessmentType) {
      setSuccessMessage(true);
      setsuccessMessageText("Please select an assessment type");
    } else {
      setSelectQuestionsMode(mode);
      let newTestType;
      if (assessmentType === "technical") {
        newTestType = mode === "auto" ? 7 : 8;
      } else {
        newTestType = mode === "auto" ? 4 : 5;
      }
      setCategoryId(categoryId);
      setTestType(newTestType);
      setSkill("");
      setTopic("");
      if (mode === "manual") {
        await dispatch(resetQuestions());
        if (assessmentType === "technical") {
          // await dispatch(getCodingAdditionalQuestion('', skill?.value || 0, topic?.value || 0, level?.value || 0, 0, 1, testsPerPage, 0));
          await dispatch(resetLoadingQuestions());
        } else {
          await dispatch(
            getv2AdditionalQuestion(
              "",
              skill?.value || 0,
              topic?.value || 0,
              level?.value || 0,
              0,
              1,
              testsPerPage
            )
          );
        }
        await dispatch(getSkills(1));
      }
    }
  };

  const fetchManualData = async () => {
    setIsQuestionLoadingCustom(true);
    try {
      if (testType === 8) {
        await setQuesPage(quesPage + 1);
        await dispatch(
          getCodingAdditionalQuestion(
            searchQues,
            skill?.value || 0,
            topic?.value || 0,
            level?.value || 0,
            0,
            quesPage + 1,
            testsPerPage,
            selectedCodingLanguage?.value || 0
          )
        );
      } else {
        await setQuesPage(quesPage + 1);
        await dispatch(
          getNextv2AdditionalQuestion(
            searchQues,
            skill?.value || 0,
            topic?.value || 0,
            level?.value || 0,
            0,
            quesPage + 1,
            testsPerPage
          )
        );
      }
    } finally  {
      setIsQuestionLoadingCustom(false);
    }
  };

  const setskill = async (e) => {
    setSkill(e);
    setTopic("");
    await dispatch(emptyTopics());
    if (e?.value) {
      await dispatch(
        getSkillTopics(1, e?.value, testType, selectedCodingLanguage?.value)
      );
    }
  };

  const setTags = async (e) => {
    await setTopic(e);
    await dispatch(resetQuestions());
    setIsQuestionLoadingCustom(true);

    try {
      if (testType === 8) {
        await dispatch(
          getCodingAdditionalQuestion(
            searchQues,
            skill?.value || 0,
            e?.value || 0,
            level?.value || 0,
            0,
            1,
            testsPerPage,
            selectedCodingLanguage?.value || 0
          )
        );
      } else {
        await dispatch(
          getv2AdditionalQuestion(
            searchQues,
            skill?.value || 0,
            e?.value || 0,
            level?.value || 0,
            0,
            1,
            testsPerPage
          )
        );
      }
    } finally {
      setIsQuestionLoadingCustom(false);
    }
  };

  const handleSearch = async (val) => {
    setSearchQues(val);
    setIsQuestionLoadingCustom(true);
    
    try {
      if (testType === 8) {
        await dispatch(
          getCodingAdditionalQuestion(
            val,
            skill?.value || 0,
            topic?.value || 0,
            level?.value || 0,
            0,
            1,
            testsPerPage,
            selectedCodingLanguage?.value || 0
          )
        );
      } else {
        await dispatch(
          getv2AdditionalQuestion(
            val,
            skill?.value || 0,
            topic?.value || 0,
            level?.value || 0,
            0,
            1,
            testsPerPage
          )
        );
      }
    } finally {
      setIsQuestionLoadingCustom(false);
    }

  };

  const selectSource = async (e) => {
    setQSource(e);
    setSkill("");
    setTopic("");
    setSelectedCodingLanguage(null);
    dispatch(resetLanguages());
    dispatch(resetSkills());
    dispatch(resetTopics());
    if (testType === 7) {
      await dispatch(
        getCodingQuestionLanguages((res) => {
          if (res?.payload?.languages) {
            setCodingLanguages(res.payload.languages);
          }
        })
      );
    } else if (testType === 8) {
      dispatch(resetSkills());
      dispatch(resetTopics());
    } else {
      const res = await dispatch(
        getSkills(e.value, testType, selectedCodingLanguage?.value)
      );
      await dispatch(getQuestionLevels());
      if (res?.type === "NO_SKILLS") {
        setSuccessMessage(true);
        setsuccessMessageText("No Knowledge Areas found for this language");
      }
    }
  };

  const selectSkill = async (e) => {
    setSkill(e);
    const res = await dispatch(
      getSkillTopics(
        qSource?.value,
        e.value,
        testType,
        selectedCodingLanguage?.value
      )
    );
    if (res?.type === "NO_TOPICS") {
      setSuccessMessage(true);
      setsuccessMessageText("No Topics found for this Knowledge Area");
    }
  };

  const isDuplicateTopic = (topicId, newLevel, currentTestTopicId = null) => {
    return automaticQues.some((item) => {
      if (currentTestTopicId && item.testTopicId === currentTestTopicId) {
        return false;
      }
      if (item.skillTopicId !== topicId) return false;
      const existingLevel = item.questionLevel;
      if (newLevel === 0) return true;
      if (existingLevel === 0) return true;
      if (existingLevel === newLevel) return true;

      return false;
    });
  };

  const selectSkillTopic = async (e) => {
    setTopic(e);
    setLevel("");
    setQCount("");
    setCountOption([]);
    if (testType !== 7) {
      const res = await dispatch(
        getQuestionCount(qSource?.value, skill?.value, e?.value, 0)
      );

      if (res?.type === "GET_COUNT") {
        let arr = Array.from({ length: res.payload }, (_, i) => ({
          label: i + 1,
          value: i + 1,
        }));

        setCountOption(arr);
        setQCount({ label: res.payload, value: res.payload });
      }
    }
  };

  const selectLevel = async (e) => {
    const newLevel = e.value;

    // Run duplicate logic ONLY when topic + level are selected
    if (isDuplicateTopic(topic?.value, newLevel)) {
      setLevel("");
      setTopic("");
      setQCount("");
      setSuccessMessage(true);
      setsuccessMessageText("This topic with this question level is not allowed");
      return;
    }

    // Normal flow
    setLevel(e);

    if (testType === 7) return;

    const res = await dispatch(
      getQuestionCount(qSource?.value, skill?.value, topic?.value, newLevel)
    );

    if (res?.type === "GET_COUNT") {
      let arr = Array.from({ length: res.payload }, (_, i) => ({
        label: i + 1,
        value: i + 1,
      }));
      setCountOption(arr);
      setQCount({ label: res.payload, value: res.payload });
    }
  };

  const addMore = async () => {
    if (!qSource?.value) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Select Question Source");
      return;
    }

    if (!qCount?.value) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Select Question Count");
      return;
    }

    const obj = {
      skillId: skill?.value,
      skillTopicId: topic?.value,
      questionCount: qCount?.value,
      questionSourceId: qSource?.value,
      questionLevel: level?.value,
      levelName: level?.label,
      sourceName: qSource?.label,
      skillName: skill?.label,
      topicName: topic?.label,
      // ✅ Save language snapshot per topic
      ...(testType === 7 && selectedCodingLanguage?.value
        ? {
            codingLanguageId: selectedCodingLanguage.value,
            codingLanguageName: selectedCodingLanguage.label,
          }
        : {}),
    };

    setIsLoading(true);
    setAutomaticQues((prev) => [...prev, obj]);
    setTopic("");
    setLevel("");
    setQCount("");
    setIsLoading(false);
  };

  useEffect(() => {
    // if (editDetails) return;

    const updateDuration = async () => {
      let newDuration = 0;

      if (testType === 4 || testType === 7) {
        newDuration = await getTotal(automaticQues, "ques");
      } else {
        newDuration = selectedQuestion?.reduce(
          (sum, q) => sum + (q.duration || 0),
          0
        );
      }

      if (newDuration < 1) newDuration = 1;

      await setDuration(newDuration);
    };

    updateDuration();
  }, [automaticQues, selectedQuestion, testType]);

  useEffect(() => {
    const fetchCodingQuestionCount = async () => {
      if (
        testType === 7 &&
        qSource?.value &&
        skill?.value &&
        topic?.value &&
        level?.value !== undefined &&
        selectedCodingLanguage?.value
      ) {
        const res = await dispatch(
          getCodingQuestionCount(
            qSource?.value,
            skill?.value,
            topic?.value,
            level?.value,
            selectedCodingLanguage?.value
          )
        );
        if (res?.type === "GET_COUNT") {
          let arr = Array.from({ length: res.payload }, (_, i) => ({
            label: i + 1,
            value: i + 1,
          }));
          setCountOption(arr);
          setQCount({ label: res.payload, value: res.payload });
        }
      }
    };

    fetchCodingQuestionCount();
  }, [
    dispatch,
    testType,
    qSource,
    skill,
    topic,
    level,
    selectedCodingLanguage,
  ]);

  const clearResponse = async () => {
    await setSkill("");
    await setSelectedCodingLanguage("");
    await setQSource("");
    await setTopic("");
    await setLevel("");
    await setQCount("");
  };

  const removeFromList = (data) => {
    const filtered = automaticQues.filter(
      (el) =>
        !(
          el.skillId === data.skillId &&
          el.skillTopicId === data.skillTopicId &&
          el.questionLevel === data.questionLevel
        )
    );

    setAutomaticQues(filtered);
  };

  const editAutoTopic = async (data) => {
    await setIsEditTopic(true);
    await setEditTopicDetail(data);
    await dispatch(getSkills(data?.questionSourceTypeId));
    await dispatch(
      getSkillTopics(
        data?.questionSourceTypeId,
        data.skillId,
        testType,
        selectedCodingLanguage?.value
      )
    );
    await dispatch(getQuestionLevels());
    const res = await dispatch(
      getQuestionCount(
        data?.questionSourceTypeId,
        data.skillId,
        data.skillTopicId,
        data.questionLevelId
      )
    );
    await setEditTopicDetail({
      ...editTopicDetail,
      ...data,
      questionCount: res.payload,
    });
  };

  const handleEdit = async (e, field) => {
    if (field === "skill") {
      setEditTopicDetail({
        ...editTopicDetail,
        skillName: e.label,
        skillId: e.value,
        skillTopicName: null,
        skillTopicId: null,
        questionCount: "",
        questionLevelName: null,
        questionLevelId: null,
      });
      dispatch(getSkillTopics(editTopicDetail?.questionSourceTypeId, e.value));
    } else if (field === "topic") {
      setEditTopicDetail({
        ...editTopicDetail,
        skillTopicName: e.label,
        skillTopicId: e.value,
        questionLevelName: null,
        questionLevelId: null,
        questionCount: "",
      });
      // const res = await dispatch(getQuestionCount(editTopicDetail?.questionSourceTypeId, editTopicDetail.skillId, editTopicDetail.skillTopicId, editTopicDetail?.questionLevelId));
      const res = await dispatch(
        getQuestionCount(
          editTopicDetail?.questionSourceTypeId,
          editTopicDetail.skillId,
          e.value,
          0
        )
      );
      if (res?.type === "GET_COUNT") {
        let arr = Array.from({ length: res.payload }, (_, i) => ({
          label: i + 1,
          value: i + 1,
        }));
        setCountOption(arr);
        setEditTopicDetail((prev) => ({ ...prev, questionCount: res.payload }));
      }
    } else if (field === "level") {
      setEditTopicDetail({
        ...editTopicDetail,
        questionLevelName: e.label,
        questionLevelId: e.value,
      });
      // const res = await dispatch(getQuestionCount(editTopicDetail?.questionSourceTypeId, editTopicDetail.skillId, editTopicDetail.skillTopicId, e.value));
      const res = await dispatch(
        getQuestionCount(
          editTopicDetail?.questionSourceTypeId,
          editTopicDetail.skillId,
          editTopicDetail.skillTopicId,
          e.value
        )
      );
      // await setEditTopicDetail({ ...editTopicDetail, questionCount: res.payload });
      if (res?.type === "GET_COUNT") {
        let arr = Array.from({ length: res.payload }, (_, i) => ({
          label: i + 1,
          value: i + 1,
        }));
        setCountOption(arr);
        setEditTopicDetail((prev) => ({ ...prev, questionCount: res.payload }));
      }
    } else if (field === "quesCount") {
      setEditTopicDetail({
        ...editTopicDetail,
        questionCount: Number(e.value),
      });
    }
  };

  const replaceObjectInArray = (array, _id, newObject) => {
    const idMap = new Map(array.map((obj) => [obj.testTopicId, obj]));
    if (idMap.has(_id)) {
      idMap.set(_id, { ...newObject });
      return Array.from(idMap.values());
    }
    return array;
  };

  const updateTopicDetail = () => {
    setIsEditTopic(false);
    const found = replaceObjectInArray(
      automaticQues,
      editTopicDetail?.testTopicId,
      editTopicDetail
    );
    setAutomaticQues(found);
    setEditTopicDetail(null);
  };

  const saveTest = async () => {
    if (
      testType === 4 || testType === 7
        ? !automaticQues?.length
        : !selectedQuestion?.length
    ) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Select Questions");
    } else {
      await setLoading(true);
      let obj;

      if (testType === 7) {
        obj = {
          testName,
          duration: duration
            ? Number(duration)
            : getTotal(automaticQues, "ques") * 1,
          questionCount: getTotal(automaticQues, "ques"),
          testType,
          randomize: 1,
          isRandomized: true,
          topics: automaticQues?.map((el) => ({
            skillId: el.skillId,
            skillTopicId: el.skillTopicId,
            questionCount: el.questionCount,
            questionSourceId: el.questionSourceId,
            questionLevel: el.questionLevel,
            questionTypeIds: getQuestionTypeIds(
              assessmentType,
              testType,
              categoryId
            ),
            questionLevelIds:
              !el.questionLevel || el.questionLevel === 0
                ? []
                : [el.questionLevel],
            codingLanguageIds: [
              el.codingLanguageId || selectedCodingLanguage?.value,
            ].filter(Boolean),
            data: null,
          })),
          questions: [],
          questionWithCodingLanguages: [],
        };
      } else if (testType === 4) {
        obj = {
          testName: testName,
          duration: duration
            ? Number(duration)
            : getTotal(automaticQues, "ques") * 1,
          questionCount: getTotal(automaticQues, "ques"),
          testType: testType,
          topics: automaticQues?.map(
            (el) =>
              [
                {
                  skillId: el.skillId,
                  skillTopicId: el.skillTopicId,
                  questionCount: el.questionCount,
                  questionSourceId: el.questionSourceId,
                  questionLevel: el.questionLevel,
                },
              ][0]
          ),
          questions: [],
        };
      } else if (testType === 8) {
        obj = {
          testName,
          duration: duration ? Number(duration) : selectedQuestion?.length * 1,
          questionCount: selectedQuestion?.length,
          testType,
          randomize: 1,
          isRandomized: true,
          topics: [],
          questions: [],
          questionWithCodingLanguages:
            selectedQuestion?.map((q) => ({
              questionId: q.id || q.questionID || 0,
              // codingLanguageIds: [selectedCodingLanguage?.value],
              // })) || [
              // { questionId: 0, codingLanguageIds: [selectedCodingLanguage?.value] }
              // ]
              codingLanguageIds: [
                q.codingLanguages?.[0]?.id || selectedCodingLanguage?.value,
              ].filter(Boolean),
            })) || [],
        };
      } else {
        obj = {
          testName: testName,
          duration: duration ? Number(duration) : selectedQuestion?.length * 1,
          questionCount: selectedQuestion?.length,
          testType: testType,
          topics: [],
          questions: selectedQuestion?.map((el) => el.questionID),
        };
      }
      if ([7, 8, 12, 13].includes(testType)) {
        obj.categoryId = categoryId;
      }

      const res = await dispatch(savedTest(obj));
      if (res?.type === "CREATE_MY_TEST") {
        setPage(1);
        setQuery("");
        setTestType(-1);
        setEditDetails("");
        // res.payload.testId
        dispatch(getMyTests(-1, "", 1, testsPerPage));
        await dispatch(resetQuestions());
        await dispatch(saveSelectQuestion([]));
      }

      await backTomyTest();
    }
    await setLoading(false);
  };

  const editMyTest = async () => {
    if (
      testType === 4 || testType === 7
        ? !automaticQues?.length
        : !selectedQuestion?.length
    ) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Select Questions");
    } else {
      await setLoading(true);
      let obj;
      if (testType === 7) {
        obj = {
          testId: editDetails?.testId,
          testName,
          duration: duration
            ? Number(duration)
            : getTotal(automaticQues, "ques"),
          questionCount: getTotal(automaticQues, "ques"),
          testType,
          randomize: 1,
          isRandomized: true,
          topics: automaticQues?.map((el) => {
            // ✅ Determine questionLevelIds logic
            let questionLevelIds = [];
            if (el.questionLevel === 0) {
              // "All" selected
              questionLevelIds = [0];
            } else if (el.questionLevel) {
              // Specific level selected
              questionLevelIds = [el.questionLevel];
            } else {
              // Nothing selected
              questionLevelIds = [];
            }

            return {
              skillId: el.skillId,
              skillTopicId: el.skillTopicId,
              questionCount: el.questionCount,
              questionSourceId: el.questionSourceId,
              questionLevel: el.questionLevel,
              questionTypeIds: getQuestionTypeIds(
                assessmentType,
                testType,
                categoryId
              ),
              questionLevelIds, // ✅ updated logic
              codingLanguageIds: [
                el.codingLanguageId ||
                  el.codingLanguages?.[0]?.id ||
                  selectedCodingLanguage?.value,
              ].filter(Boolean),
              data: null,
            };
          }),
          questions: [],
          questionWithCodingLanguages: [],
        };
      } else if (testType === 4) {
        obj = {
          testId: editDetails?.testId,
          testName: testName,
          duration: duration
            ? Number(duration)
            : getTotal(automaticQues, "ques") * 1,
          questionCount: Number(getTotal(automaticQues, "ques")),
          testType: testType,
          topics: automaticQues?.map(
            (el) =>
              [
                {
                  skillId: el.skillId,
                  skillTopicId: el.skillTopicId,
                  questionCount: el.questionCount,
                  questionSourceId: el.questionSourceId,
                  questionLevel: el.questionLevel,
                },
              ][0]
          ),
          questions: [],
        };
      } else if (testType === 8) {
        obj = {
          testId: editDetails?.testId,
          testName,
          duration: duration ? Number(duration) : selectedQuestion?.length * 1,
          questionCount: selectedQuestion?.length,
          testType,
          randomize: 1,
          isRandomized: true,
          topics: [],
          questions: [],
          questionWithCodingLanguages:
            selectedQuestion?.map((q) => ({
              questionId: q.id || q.questionID || 0,
              // codingLanguageIds: [selectedCodingLanguage?.value],
              // })) || [
              // { questionId: 0, codingLanguageIds: [selectedCodingLanguage?.value] }
              // ]
              codingLanguageIds: [
                q.codingLanguages?.[0]?.id || selectedCodingLanguage?.value,
              ].filter(Boolean),
            })) || [],
        };
      } else {
        obj = {
          testId: editDetails?.testId,
          testName: testName,
          duration: duration ? Number(duration) : selectedQuestion?.length * 1,
          questionCount: selectedQuestion?.length,
          testType: testType,
          topics: [],
          questions: selectedQuestion?.map(
            (el) => el.questionId || el.questionID
          ),
        };
      }
      if ([7, 8, 12, 13].includes(testType)) {
        obj.categoryId = categoryId;
      }

      const res = await dispatch(updateTest(obj));
      if (res?.type === "UPDATE_MY_TEST") {
        setPage(1);
        setQuery("");
        setTestType(-1);
        setEditDetails("");
        dispatch(getMyTests(-1, "", 1, testsPerPage));
        await dispatch(resetQuestions());
        await dispatch(saveSelectQuestion([]));
      }
      await backTomyTest();
    }
    await setLoading(false);
  };

  const addToAssessment = async () => {
    if (
      testType === 4 || testType === 7
        ? !automaticQues?.length
        : !selectedQuestion?.length
    ) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Select Questions");
    } else {
      let obj =
        testType === 4
          ? {
              testName: testName,
              duration: getTotal(automaticQues, "ques") * 1,
              questionCount: getTotal(automaticQues, "ques"),
              testType: testType,
              topics: automaticQues?.map(
                (el) =>
                  [
                    {
                      skillId: el.skillId,
                      skillTopicId: el.skillTopicId,
                      questionCount: el.questionCount,
                      questionSourceId: el.questionSourceId,
                      questionLevel: el.questionLevel,
                    },
                  ][0]
              ),
              questions: [],
            }
          : {
              testName: testName,
              duration: selectedQuestion?.length * 1,
              questionCount: selectedQuestion?.length,
              testType: testType,
              topics: [],
              questions: selectedQuestion?.map((el) => el.questionID),
            };

      const res = await dispatch(savedTest(obj));
      if (res?.type === "CREATE_MY_TEST") {
        setPage(1);
        setQuery("");
        setTestType(0);
        setEditDetails("");
        navigate(`/home/select-test`, {
          state: {
            gappeoTest: false,
            detail: {
              referenceTypeId: 1,
              referenceId: res.payload.testId,
              referenceName: testName,
              testType: 0,
            },
            next: true,
          },
        });
      }
    }
  };

  const backTomyTest = () => {
    setIsNewTestPage(false);
  };

  const snackClosed = () => {
    setSuccessMessage(false);
    setsuccessMessageText("");
  };

  const goToSelectTest = (items, type) => {
    navigate(`/home/select-test`, {
      state: {
        gappeoTest: false,
        detail: {
          referenceTypeId: 1,
          referenceId: items.testID,
          referenceName: items.testName,
          testType: 0,
        },
        next: true,
      },
    });
  };

  const editDetail = (name, duration) => {
    if (!name) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Enter Test name");
    } else if (!duration || duration === 0) {
      setSuccessMessage(true);
      setsuccessMessageText("Please Enter Duration");
    } else {
      setTestName(name);
      setDuration(Number(duration));
      setIsEdit(false);
    }
  };

  const editTest = async (data) => {
    if (window.innerWidth > 767) {
      setLoading(true); // ✅ start loader immediately

      try {
        setAutomaticQues([]);
        await dispatch(resetQuestions());
        await dispatch(saveSelectQuestion([]));
        
        setIsNewTestPage(true);

        // set mode depending on testType
        if (data?.testType === 4 || data?.testType === 7) {
          setSelectQuestionsMode("auto");
        } else {
          setSelectQuestionsMode("manual");
        }

        // ✅ fetch test details
        const res = await dispatch(getTestById(data.testID));

        if (res?.type === "GET_TEST_BY_ID") {
          const testData = res.payload;

          // ✅ set core details
          setEditDetails(testData);
          setAutomaticQues(
            testData.topics?.map((topic) => ({
              ...topic,
              // Normalize language fields for testType === 7
              questionLevel: topic.questionLevelId, 
              levelName: topic.questionLevelName, 
              skillTopicId: topic.skillTopicId,
              skillId: topic.skillId,
              codingLanguageName: topic.codingLanguages?.[0]?.name || "",
              codingLanguageId: topic.codingLanguages?.[0]?.id || "",
            })) || []
          );
          setTestName(testData?.testName);
          setTestType(testData?.testType);
          setDuration(testData?.duration);

          if (testData?.categoryId) {
            setCategoryId(testData.categoryId);
          }

          setSelectedCodingLanguage(null);

          // handle manual testType = 5
          if (testData?.testType === 5) {
            await dispatch(resetQuestions());
            await dispatch(
              getv2AdditionalQuestion(
                "",
                skill?.value || 0,
                topic?.value || 0,
                level?.value || 0,
                0,
                1,
                testsPerPage
              )
            );
            await dispatch(getSkills(1));
          }
        }
      } catch (err) {
        console.error("Edit Test Error:", err);
      } finally {
        setLoading(false); // ✅ stop loader always
      }
    } else {
      setSuccessMessage(true);
      setsuccessMessageText(
        "You can create test from Desktop.Mobile view coming soon"
      );
    }
  };

  // Pagination logic
  const totalPages = Math.ceil(total / testsPerPage);

  const paginate = async (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    await dispatch(resetMYTest());
    await dispatch(getMyTests(testType, query, pageNumber, testsPerPage));
  };

  const Pagination = ({ currentPage, totalPages, paginate }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, "...", totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, "...", totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages,
        ];
      }
    };
    return (
      <div className="pagination">
        <div className="pagination-info">
          {myTests.length > 0 ? (
            <span>
              Showing <strong>{(currentPage - 1) * testsPerPage + 1}</strong>-
              <strong>
                {(currentPage - 1) * testsPerPage + myTests.length}
              </strong>{" "}
              of <strong>{total}</strong>
            </span>
          ) : (
            <span>Showing 0-0 of 0</span>
          )}
        </div>
        <div className="pagination-buttons">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <img src="/images/leftarrow-icon.svg" alt="" />
          </button>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => (page === "..." ? null : paginate(page))}
              className={currentPage === page ? "active" : ""}
              disabled={page === "..."}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt=""
              style={{ rotate: "180deg" }}
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="gappeo-my-tests">
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={successMessage}
        onClose={snackClosed}
        autoHideDuration={4000}
      >
        <Alert onClose={snackClosed} severity="error" sx={{ width: "100%" }}>
          {successMessageText}
        </Alert>
      </Snackbar>
      <Dialog
        className="screen-loader"
        open={loading}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        Loading...
      </Dialog>
      {isNewTestPage ? (
        selectQuestionsMode === "auto" ? (
          <div className="newtests">
            <div className="textclass d-flex align-items-center pb-2">
              <img
                className="backarrow manuallback"
                src="images/leftarrow-black-icon.svg"
                onClick={goBackNewTest}
                alt=""
              />
              <h1 className="newtestpage">Test Summary</h1>
            </div>
            <Card className="summarycard">
              <div className="summaryheader d-flex justify-content-center align-items-center">
                <div className="headeritem">
                  <img
                    className="editimg"
                    src="/images/info-wight.svg"
                    alt=""
                  />
                  &nbsp;&nbsp;
                  <div className="">
                    <p>Test Name</p>
                    <div className="d-flex mt-1 align-item-center">
                      <h4>{testName}</h4> &nbsp;&nbsp;
                      <img
                        src="/images/edit-pink-icon.svg"
                        className="cursor-pointer"
                        alt=""
                        onClick={() => setIsEdit(true)}
                      />
                    </div>
                  </div>
                </div>
                <div className="headeritem">
                  <img
                    className="editimg"
                    src="/images/ph_question-light-wight.svg"
                    alt=""
                  />
                  &nbsp;
                  <div className="">
                    <p>Questions</p>
                    <div className="d-flex mt-1 align-item-center">
                      <h4>{getTotal(automaticQues, "ques")}</h4>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                </div>
                <div className="headeritem">
                  <img
                    className="editimg"
                    src="/images/lets-icons_time-progress-light-wight.svg"
                    alt=""
                  />
                  &nbsp;
                  <div className="">
                    <p>Minutes</p>
                    <div className="d-flex mt-1 align-item-center">
                      <h4>{duration}</h4> &nbsp;&nbsp;&nbsp;&nbsp;
                      <img
                        className="cursor-pointer"
                        src="/images/edit-pink-icon.svg"
                        onClick={() => setIsEdit(true)}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="summarybody">
                <div className="summaryfiels d-flex justify-content-center align-items-center">
                  <div className="summaryfiels-dropdowns">
                    <Select
                      components={{ DropdownIndicator }}
                      placeholder="Questions Source"
                      options={questionSource}
                      value={qSource}
                      onChange={(e) => selectSource(e)}
                    />
                  </div>
                  {testType === 7 && (
                    <div className="summaryfiels-dropdowns">
                      <Select
                        components={{ DropdownIndicator }}
                        placeholder="Language"
                        isDisabled={!qSource?.value}
                        options={
                          codingQuestionLanguagesOptions
                            ?.filter((lang) => lang.category?.id === categoryId)
                            ?.map((lang) => ({
                              label: lang.displayLanguage,
                              value: lang.id,
                            })) || []
                        }
                        value={selectedCodingLanguage}
                        onChange={async (e) => {
                          setSelectedCodingLanguage(e);
                          setSkill("");
                          setTopic("");
                          dispatch(resetSkills());
                          dispatch(resetTopics());
                          if (e?.value && (testType === 7 || testType === 8)) {
                            await dispatch(getSkills(qSource.value, testType, e.value));
                          }
                        }}
                        isClearable
                        isMulti={false}
                      />
                    </div>
                  )}
                  <div className="summaryfiels-dropdowns">
                    <Select
                      components={{ DropdownIndicator }}
                      placeholder="Knowledge Area"
                      options={skills}
                      value={skill}
                      onChange={(e) => selectSkill(e)}
                      // isDisabled={!qSource?.value}
                      isDisabled={
                        testType === 7 || testType === 8
                          ? !selectedCodingLanguage?.value
                          : !qSource?.value
                      }
                    />
                  </div>
                  <div className="summaryfiels-dropdowns">
                    <Select
                      components={{ DropdownIndicator }}
                      placeholder="Topics / Tags"
                      options={topics}
                      value={topic}
                      onChange={(e) => selectSkillTopic(e)}
                      isDisabled={!skill?.value}
                    />
                  </div>
                  <div className="summaryfiels-dropdowns">
                    <Select
                      components={{ DropdownIndicator }}
                      placeholder="Question Level"
                      options={[
                        { label: "All", value: 0 },
                        ...questionLevel?.map(
                          (el) =>
                            [
                              {
                                label: el.questionLevelName,
                                value: el.questionLevelID,
                              },
                            ][0]
                        ),
                      ]}
                      value={level}
                      onChange={(e) => selectLevel(e)}
                      isDisabled={!topic?.value}
                    />
                  </div>
                  <div className="summaryfiels-dropdowns">
                    <Select
                      components={{ DropdownIndicator }}
                      placeholder="#Question"
                      options={countOption}
                      value={qCount}
                      onChange={(e) => setQCount(e)}
                      isDisabled={!level?.value}
                    />
                  </div>
                </div>
                <div className="d-flex align-items-center mt-3">
                  <button
                    className="generate-btn"
                    disabled={
                      qSource === "" ||
                      skill === "" ||
                      topic === "" ||
                      level === "" ||
                      qCount === ""
                    }
                    onClick={addMore}
                    style={{ border: "none" }}
                  >
                    Add More
                  </button>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <h5 className="action" onClick={clearResponse}>
                    Clear Selection
                  </h5>
                </div>
                <hr />
                <div
                  id="scroll"
                  style={{ maxHeight: 400, minHeight: 333, overflow: "auto" }}
                >
                  <div className="mt-2">
                    <div className="testupdate">
                      {testType === 7 && (
                        <div className="testsummary">
                          <h3>Language</h3>
                        </div>
                      )}
                      <div className="testsummary">
                        <h3>Knowledge Area</h3>
                      </div>
                      <div className="testsummary">
                        <h3>Topic/tags</h3>
                      </div>
                      <div className="testlevel">
                        <p style={{ fontWeight: 700 }}>Question Level</p>
                      </div>
                      <div className="testlevel">
                        <p style={{ fontWeight: 700 }}>Questions</p>
                      </div>
                      <div className="testitems">
                        <p style={{ color: "#555c5e", fontWeight: 700 }}>
                          Action
                        </p>
                      </div>
                    </div>
                  </div>
                  {automaticQues?.length > 0 ? (
                    automaticQues?.map((el, i) => {
                      return (
                        <Card className="mt-2" key={i}>
                          <div className="testupdate">
                            {testType === 7 && (
                              <div className="testsummary">
                                <h3>{el.codingLanguageName}</h3>
                              </div>
                            )}
                            <div className="testsummary">
                              <h3>{el.skillName}</h3>
                            </div>
                            <div className="testsummary">
                              <p>{el.topicName || el.skillTopicName}</p>
                            </div>
                            <div className="testlevel">
                              <p>
                                {el.levelName ||
                                  el.questionLevelName ||
                                  (el.questionLevelId === 0 ? "All" : "")}
                              </p>
                            </div>
                            <div className="testlevel">
                              <p>{el.questionCount} Questions</p>
                            </div>
                            <div className="testitems">
                              {/* {editDetails && (
                                <img
                                  className="testicons cursor-pointer"
                                  src="/images/edit-icon.svg"
                                  alt=""
                                  onClick={() => editAutoTopic(el)}
                                />
                              )} */}
                              <img
                                className="testicons cursor-pointer"
                                src="/images/delete-color-icon.svg"
                                alt=""
                                onClick={(e) => removeFromList(el)}
                              />
                            </div>
                          </div>
                        </Card>
                      );
                    })
                  ) : (
                    <div>
                      <p>
                        {testType === 7
                          ? "You have not added any coding questions yet"
                          : "You have not added any question yet"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </Card>
            <div className="d-flex">
              <button
                className="generate-btn"
                style={{ background: "#f75891", border: "1px soli #f75891" }}
                onClick={editDetails ? editMyTest : saveTest}
              >
                Save & Exit
              </button>
              &nbsp;&nbsp;&nbsp;
              <button className="outline-btn" onClick={addToAssessment}>
                Add To Assessment
              </button>
            </div>
          </div>
        ) : selectQuestionsMode === "manual" ? (
          <SelectQuestions
            isQuestionLoading={isQuestionLoading}
            additionalQuestions={additionalQuestions}
            total={totalQues}
            fetchData={fetchManualData}
            goBackNewTest={goBackNewTest}
            backTomyTest={backTomyTest}
            selectOneQuestion={(val, checked, detail) => {
              dispatch(selectOneQuestion(val, checked, detail));
            }}
            selectedQuestion={selectedQuestion}
            removeQuestion={(data) => dispatch(removeQuestion(data))}
            saveSelectQuestion={(data) => dispatch(saveSelectQuestion(data))}
            skills={skills}
            setSkill={setskill}
            setTags={setTags}
            topics={topics}
            testName={testName}
            duration={duration}
            openEdit={() => setIsEdit(true)}
            saveTest={saveTest}
            addToAssessment={addToAssessment}
            handleSearch={handleSearch}
            editDetails={editDetails}
            editMyTest={editMyTest}
            isLoading={isLoading}
            selectedCodingLanguage={selectedCodingLanguage}
            setSelectedCodingLanguage={setSelectedCodingLanguage}
            testType={testType}
            dispatch={dispatch}
            getSkills={getSkills}
            getSkillTopics={getSkillTopics}
            categoryId={categoryId}
            setSuccessMessage={setSuccessMessage}
            setsuccessMessageText={setsuccessMessageText}
            customLoader={isQuestionLoadingCustom}
          />
        ) : (
          <div className="newtests test-options">
            <div className="textclass d-flex">
              <img
                className="backarrow"
                src="images/leftarrow-black-icon.svg"
                onClick={goBack}
                alt=""
              />
              <h1 className="newtestpage">New Test</h1>
            </div>
            <div
              className="search-tests  mt-3"
              style={{ paddingTop: "1.5rem" }}
            >
              <div className="has-search">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  placeholder="Enter Test name"
                  value={testName}
                  onChange={(e) => handleTestName(e.target.value)}
                />
              </div>
              <div style={{ color: "red", marginTop: 5 }}>{testNameErr}</div>
            </div>
            <div className="test-selection">
              <h3 className="mt-3 mb-3">Choose Test Type</h3>
              <div className="d-flex gap-3">
                <div className="d-flex gap-2 align-items-center">
                  <input
                    className="round-checkbox"
                    type="checkbox"
                    id="general"
                    checked={assessmentType === "general"}
                    onChange={() => setAssessmentType("general")}
                  />
                  <label htmlFor="general">General Assessment</label>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <input
                    className="round-checkbox"
                    type="checkbox"
                    id="technical"
                    checked={assessmentType === "technical"}
                    onChange={() => setAssessmentType("technical")}
                  />
                  <label htmlFor="technical">Technical Assessment</label>
                </div>
              </div>
            </div>
            {assessmentType === "technical" && (
              <div className="mt-3">
                <h3 className="mt-3 mb-3">Select Category</h3>
                <div className="d-flex gap-3">
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      className="round-checkbox"
                      type="checkbox"
                      id="programming"
                      checked={categoryId === 1}
                      onChange={() => setCategoryId(1)}
                    />
                    <label htmlFor="programming">Programming / Coding</label>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      className="round-checkbox"
                      type="checkbox"
                      id="database"
                      checked={categoryId === 2}
                      onChange={() => setCategoryId(2)}
                    />
                    <label htmlFor="database">Database</label>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <input
                      className="round-checkbox"
                      type="checkbox"
                      id="datascience"
                      checked={categoryId === 3}
                      onChange={() => setCategoryId(3)}
                    />
                    <label htmlFor="datascience">
                      DataScience with Jupyter Notebook
                    </label>
                  </div>
                </div>
              </div>
            )}
            <div>
              <h3 className="mt-4">Select Question Mode</h3>
              <div className="d-flex">
                <Card className="testscart">
                  <img src="/images/list-timeline.svg" alt="" width={32} />
                  <Card.Body className="cardbody">
                    <h3>Select questions automatically</h3>
                    <p className="BodyText">
                      Questions will be selected based on the knowledge area and
                      topics you choose
                    </p>
                    <button
                      className="mytestbtn"
                      disabled={testNameErr}
                      onClick={() => setMode("auto")}
                    >
                      Continue
                    </button>
                  </Card.Body>
                </Card>{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Card className="testscart">
                  <img src="/images/choose 1.svg" alt="" width={32} />
                  <Card.Body className="cardbody">
                    <h3>Select questions manually</h3>
                    <p className="BodyText">
                      Select from a list of questions and add them to the test
                    </p>
                    <button
                      className="mytestbtn"
                      disabled={testNameErr}
                      onClick={() => setMode("manual")}
                    >
                      Continue
                    </button>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        )
      ) : (
        //List
        <div className="newtests">
          <div className="d-flex justify-content-between align-items-center">
            <h1>My Tests</h1>
            <button className="mytestbtn" onClick={createTest}>
              NEW TEST
            </button>
          </div>
          <p className="caption">
            Custom tests that you can create yourself and add to assessments
          </p>
          <div className="table-content">
            <div className="my-tests d-flex">
              <div className="has-search" style={{ width: "82%" }}>
                <span className="form-control-feedback">
                  <img src="/images/search.svg" alt="" width={12} />
                </span>
                <input
                  type="search"
                  className="form-control"
                  value={query}
                  placeholder="Search for test"
                  onChange={(e) => searchTest(e.target.value)}
                />
              </div>
              <div style={{ width: "18%" }}>
                <select
                  value={testType}
                  onChange={(e) => selectTestType(e.target.value)}
                >
                  <option hidden>Question Type</option>
                  <option value={-1}>All</option>
                  {testTypes?.map((el) => {
                    return <option value={el.id}>{el.name}</option>;
                  })}
                </select>
              </div>
            </div>
            {isLoading ? (
              "Loading.."
            ) : (
              <div className="table-admin">
                <Table responsive className="test-table">
                  <thead>
                    <tr>
                      <th>TEST NAME</th>
                      <th></th>
                      <th>TEST TYPE</th>
                      <th>QUESTION/DURATION</th>
                      <th>EDIT</th>
                      <th>ADD</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isTestLoading ? (
                      <tr>
                        <td colSpan="10">
                          <div
                            className="loading-overlay"
                            style={{
                              alignItems: "start",
                              color: "#F75891",
                              height: "auto",
                            }}
                          >
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">
                                Loading tests...
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : myTests?.length > 0 ? (
                      myTests.map((el) => (
                        <tr key={el.id}>
                          <td>
                            <h4>{el.testName}</h4>
                          </td>
                          <td>
                            <h5>{el.Level}</h5>
                          </td>
                          <td>
                            <h5>
                              {el.testType === 4
                                ? "Automatic"
                                : el.testType === 7
                                ? "Technical Automatic"
                                : el.testType === 8
                                ? "Technical Manual"
                                : "Manual"}
                            </h5>
                          </td>
                          <td>
                            <h5>
                              {el.questionCount} Qs | {el.duration} Mins
                            </h5>
                          </td>
                          <td className="cursor-pointer">
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => editTest(el)}
                              >
                                {/* {el.canEdit === 1 ? <img className='' src='/images/edit-black-icon.svg' alt='' onClick={() => editTest(el)} /> : null} */}
                                Edit
                              </button>
                            </div>
                          </td>
                          <td className="cursor-pointer">
                            <div className="d-flex align-items-center">
                              <button
                                className="create"
                                onClick={() => goToSelectTest(el)}
                              >
                                Add
                              </button>
                            </div>
                            {/* <img className='' src='/images/add-icon1.svg' alt='' onClick={() => goToSelectTest(el)} /> */}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10">
                          <h3>There is no tests</h3>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  paginate={paginate}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <EditTestModal
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        automaticQues={automaticQues}
        testName={testName}
        time={duration}
        editDetail={editDetail}
      />

      {/* ############################# Edit Topic Modal ########################### */}

      <Modal
        show={isEditTopic}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName={"add-test-content"}
      >
        <Modal.Body>
          <div className="sticky-close">
            <img
              src="/images/close.svg"
              alt=""
              onClick={() => setIsEditTopic(false)}
            />
          </div>
          <div className="summaryfiels">
            <div className="form-group mt-2" style={{ width: "100%" }}>
              <Select
                components={{ DropdownIndicator }}
                placeholder="Knowledge Area"
                options={skills}
                name="skill"
                value={{
                  label: editTopicDetail?.skillName,
                  value: editTopicDetail?.skillId,
                }}
                onChange={(e) => handleEdit(e, "skill")}
                // isDisabled={!qSource?.value}
              />
            </div>
            <div className="form-group mt-2" style={{ width: "100%" }}>
              <Select
                components={{ DropdownIndicator }}
                placeholder="Topics / Tags"
                name="topic"
                options={topics}
                value={{
                  label: editTopicDetail?.skillTopicName,
                  value: editTopicDetail?.skillTopicId,
                }}
                onChange={(e) => handleEdit(e, "topic")}
              />
            </div>
            <div className="form-group mt-2" style={{ width: "100%" }}>
              <Select
                components={{ DropdownIndicator }}
                placeholder="Question Level"
                name="level"
                options={[
                  { label: "All", value: 0 },
                  ...questionLevel?.map(
                    (el) =>
                      [
                        {
                          label: el.questionLevelName,
                          value: el.questionLevelID,
                        },
                      ][0]
                  ),
                ]}
                value={{
                  label:
                    editTopicDetail?.questionLevelId === 0
                      ? "All"
                      : editTopicDetail?.questionLevelName,
                  value: editTopicDetail?.questionLevelId ?? 0,
                }}
                onChange={(e) => handleEdit(e, "level")}
              />
            </div>
            <div className="form-group mt-2" style={{ width: "100%" }}>
              <Select
                components={{ DropdownIndicator }}
                placeholder="#Question"
                options={countOption}
                value={{
                  label: editTopicDetail?.questionCount,
                  value: editTopicDetail?.questionCount,
                }}
                onChange={(e) => handleEdit(e, "quesCount")}
              />
              {/* <input type='number' required style={{ height: 48, borderRadius: 0 }} className='form-control' placeholder='#Questions' value={editTopicDetail?.questionCount} onChange={(e) => handleEdit(e.target.value, 'count')} /> */}
            </div>
          </div>

          <div className="form-group">
            <div className="d-flex justify-content-center">
              <button
                className="form-control position-relative"
                onClick={() => {
                  updateTopicDetail();
                }}
              >
                Update
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MyTests;
